/**
 * Plugin registry — canonical plugin IDs (WordPress-style slugs).
 * Used by admin sidebar, route guards, and storefront feature checks.
 */
export const PLUGIN_IDS = {
  CONTACT_FORM: 'contact-form',
  WHATSAPP_BUTTON: 'whatsapp-button',
  PROMOTIONS: 'promotions',
  COUPONS: 'coupons',
  DYNAMIC_MENUS: 'dynamic-menus',
  HEADER_BUILDER: 'header-builder',
  FOOTER_BUILDER: 'footer-builder',
  SEO: 'seo-optimizer',
  REVIEWS: 'product-reviews',
  RMA: 'rma-returns',
  STATIC_PAGES: 'static-pages',
  THEME: 'theme-customizer',
  MULTI_CURRENCY: 'multi-currency',
  WISHLIST: 'wishlist',
  LOYALTY: 'loyalty-program',
  HOME_BANNER_SLIDER: 'home-banner-slider',
  BLOG: 'blog',
  SOCIAL_LOGIN: 'social-login',
  SAVINGS_SCHEMES: 'savings-schemes',
  SHIPPING_CALCULATOR: 'shipping-calculator',
} as const

export type PluginId = (typeof PLUGIN_IDS)[keyof typeof PLUGIN_IDS] | string

export type PluginStatus = 'active' | 'inactive' | 'available'

/** Returns true when the plugin is installed and active. */
export function isPluginActive(activePlugins: string[] | undefined, pluginId: string): boolean {
  return activePlugins?.includes(pluginId) ?? false
}
